import { axiosInstance } from '../axios';

import {
  CompletedUpdateRequestType,
  CompletedUpdateResponseType,
  GetCompletedStatusRequestType,
  GetCompletedStatusResponseType,
} from '@/shared/types/api/api.checkCommentMention';

export const getCompletedStatus = async ({
  groupId,
  customerId,
}: GetCompletedStatusRequestType): Promise<GetCompletedStatusResponseType> => {
  const { data } = await axiosInstance.get<GetCompletedStatusResponseType>(
    `/group/${groupId}/check-comment-mention/status/${customerId}`,
  );
  return data;
};

export const updateCompleted = async (
  groupId: number,
  customerId: number,
  requestBody: CompletedUpdateRequestType,
): Promise<CompletedUpdateResponseType> => {
  const { data } = await axiosInstance.put<CompletedUpdateResponseType>(
    `/group/${groupId}/check-comment-mention/${customerId}`,
    {
      ...requestBody,
    },
  );
  return data;
};
